import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      stroke: "#A8B4C7",
      "stroke-linecap": "round",
      "stroke-width": ".88"
    }, [
      _createElementVNode("path", {
        "stroke-linejoin": "round",
        d: "M10.533 11.924a4.9 4.9 0 0 1-2.282.736c-.85.057-1.738.057-2.586 0-.292-.02-.61-.089-.885-.202-.305-.126-.458-.188-.536-.179-.077.01-.19.092-.415.258-.396.293-.896.503-1.638.485-.375-.009-.562-.014-.646-.156-.084-.144.02-.342.23-.738.29-.55.473-1.178.195-1.682-.48-.72-.887-1.572-.946-2.493a12 12 0 0 1 0-1.501A5.16 5.16 0 0 1 2.192 3.49M3.682 2.31a4.9 4.9 0 0 1 1.983-.565 20 20 0 0 1 2.587 0c2.492.166 4.477 2.18 4.64 4.707.033.495.033 1.007 0 1.502a5.08 5.08 0 0 1-.975 2.686"
      }),
      _createElementVNode("path", { d: "m1 1 11.102 11.102" })
    ], -1)
  ])))
}
export default { render: render }